<template>
    <v-container fluid fill-height>
        <v-layout style="display: block;">
            <rework-schedules-index/>
        </v-layout>
    </v-container>
</template>
<script>
    import ReworkSchedulesIndex from "../../components/teacher/reworkSchedules/ReworkSchedulesIndex";
    export default  {
        components: {
            ReworkSchedulesIndex,
        }
    }
</script>